import React from 'react';

const fmt = (v) => (v ? new Date(v).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');
const STATUS = {
  Pending: 'bg-amber-100 text-amber-800', Qualified: 'bg-emerald-100 text-emerald-800',
  Rejected: 'bg-rose-100 text-rose-800', Reversed: 'bg-slate-200 text-slate-700',
};

export const StatusPill = ({ status, testid }) => (
  <span data-testid={testid} className={`px-2 py-0.5 rounded-full text-[11px] font-semibold ${STATUS[status] || 'bg-slate-100'}`}>{status}</span>
);

export const ReferralTable = ({ rows }) => (
  <div className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-testid="refer-table">
    <div className="px-4 py-3 border-b border-slate-100 font-semibold text-slate-900">Your referrals</div>
    {rows.length === 0 ? <p className="p-8 text-center text-sm italic text-slate-400" data-testid="refer-table-empty">No referrals yet — share your link to get started.</p> : (
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500">
          <tr>{['Clinic', 'Sign-up date', 'Plan', 'Status', 'Reward'].map((h) => <th key={h} className="text-left px-4 py-2">{h}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.referral_id} className="border-t border-slate-100" data-testid={`refer-row-${r.referral_id}`}>
              <td className="px-4 py-2 font-medium">{r.clinic_name}</td>
              <td className="px-4 py-2">{fmt(r.signup_date)}</td>
              <td className="px-4 py-2 capitalize">{r.plan || '—'}</td>
              <td className="px-4 py-2"><StatusPill status={r.status} testid={`refer-status-${r.referral_id}`} /></td>
              <td className="px-4 py-2" data-testid={`refer-reward-${r.referral_id}`}>{r.reward}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);

export const NotificationList = ({ items }) => (items.length === 0 ? null : (
  <div className="bg-white border border-slate-200 rounded-xl" data-testid="refer-notifications">
    <div className="px-4 py-3 border-b border-slate-100 font-semibold text-slate-900">Updates</div>
    <ul className="divide-y divide-slate-100">
      {items.map((n) => (
        <li key={n.notification_id} className="px-4 py-2.5 text-sm" data-testid={`refer-notification-${n.notification_id}`}>
          <div className="font-semibold text-slate-800">{n.title}</div>
          <div className="text-slate-600">{n.body}</div>
          <div className="text-[11px] text-slate-400">{fmt(n.created_at)}</div>
        </li>
      ))}
    </ul>
  </div>
));
